import type {
  Fahrerkreis,
  HaftpflichtExtras,
  KaskoExtras,
  Tarif
} from '@/types/policy/PolicyTypes'

export interface MotorContractCoverageChange {
  circleOfDrivers: Fahrerkreis
  mileage: Fahrleistung
  insuranceCover: InsuranceCover
}

export interface MotorContractCoverageChangeRequest {
  policyId: string
  dateOfChange: string
  calculatedPrice: number | null

  circleOfDrivers: Fahrerkreis | null
  mileage?: Fahrleistung | null
  insuranceCover: InsuranceCover | null | any

  isProlongation: boolean
}

export interface Fahrleistung {
  newMileage: number
  currentKmStanding: number
}

export interface InsuranceCover {
  comprehensiveCover: ComprehensiveCover
  deductible: Deductible
  liabilityBasicDiscountYear: number
  newExtras: Extras
  oldExtras: Extras
}

export interface Deductible {
  deductibleFullyComprehensive?: number
  deductiblePartiallyComprehensive?: number
}

export interface DeductibleOption {
  label: string
  value: Deductible
}

export function deductibleToString(deductible: Deductible): string {
  const result: string[] = []

  if (deductible.deductibleFullyComprehensive !== undefined) {
    result.push('Vollkasko: ' + deductible.deductibleFullyComprehensive + '€')
  }
  if (deductible.deductiblePartiallyComprehensive !== undefined) {
    result.push('Teilkasko: ' + deductible.deductiblePartiallyComprehensive + '€')
  }

  return result.join(' + ')
}

export enum ComprehensiveCover {
  NO_COMPREHENSIVE = 'NO_COMPREHENSIVE',
  PARTIALLY_COMPREHENSIVE = 'PARTIALLY_COMPREHENSIVE',
  FULLY_COMPREHENSIVE = 'FULLY_COMPREHENSIVE'
}

export interface KaskoProduct {
  productKey: string
  extras: KaskoExtras
}

export interface HaftpflichtProduct {
  productKey: string
  productTarif?: Tarif
  extras: HaftpflichtExtras
}

export interface Extras {
  liabilityProduct: HaftpflichtProduct
  comprehensiveInsuranceProduct?: KaskoProduct
}

export enum ChangeFormEnum {
  ChangeFahrleistung = 'ChangeFahrleistung',
  ChangeFahrerkreis = 'ChangeFahrerkreis',
  ChangeVersicherungsumfang = 'ChangeVersicherungsumfang'
}
